/**
 * Last-Minute Bundle — countdown persistente de 1 hora (teste)
 * ------------------------------------------------------------
 * Mostra um contador simples (apenas o tempo) junto ao título
 * "Last-Minute Bundle" no menu (mobile e desktop usam a mesma lógica).
 *
 * Regras:
 * - Duração: 1 hora a partir da primeira vez que a pessoa vê o contador.
 * - Persistente: guardado em localStorage. Se a pessoa der refresh (ou
 *   navegar para outra página do site), o tempo NÃO reinicia — continua
 *   exatamente de onde ia.
 * - Nunca "acaba" enquanto a pessoa está no site: quando chega a 0,
 *   arranca automaticamente uma nova janela de 1 hora, para o contador
 *   estar sempre a correr, independentemente do que a pessoa faça.
 *
 * IMPORTANTE: o badge do contador só é injetado nos links DO MENU
 * (desktop: .navlink--toplevel / mobile: .sliderow__title) que apontem
 * para a página do bundle — nunca em qualquer outro link/imagem do site
 * que também aponte para lá (ex.: um banner "Image banner" com o Image
 * link preenchido), para não aparecer onde não é suposto.
 */
(function () {
  'use strict';

  var TARGET_HREF = '/pages/aussie-style-edit';
  var STORAGE_KEY = 'lastMinuteBundleCountdownEnd';
  var DURATION_MS = 60 * 60 * 1000; // 1 hora
  var BADGE_SELECTOR =
    '.navlink--toplevel[href="' + TARGET_HREF + '"], ' +
    '.sliderow__title[href="' + TARGET_HREF + '"]';

  var endTime = null;

  function readStoredEnd() {
    try {
      var stored = window.localStorage.getItem(STORAGE_KEY);
      var parsed = stored ? parseInt(stored, 10) : NaN;
      return isNaN(parsed) ? null : parsed;
    } catch (e) {
      return null;
    }
  }

  function writeStoredEnd(value) {
    try {
      window.localStorage.setItem(STORAGE_KEY, String(value));
    } catch (e) {
      // localStorage indisponível (ex: modo privado) — o contador ainda
      // funciona nesta página, só não sobrevive a um refresh.
    }
  }

  // Garante um endTime válido: reaproveita o guardado se ainda não
  // passou; só cria um novo (agora + 1h) se nunca existiu ou já expirou.
  function ensureEndTime() {
    var now = Date.now();
    if (endTime !== null && now < endTime) return endTime;

    var stored = readStoredEnd();
    if (stored !== null && stored > now) {
      endTime = stored;
    } else {
      endTime = now + DURATION_MS;
      writeStoredEnd(endTime);
    }
    return endTime;
  }

  function formatDuration(ms) {
    if (ms < 0) ms = 0;
    var totalSeconds = Math.floor(ms / 1000);
    var h = Math.floor(totalSeconds / 3600);
    var m = Math.floor((totalSeconds % 3600) / 60);
    var s = totalSeconds % 60;
    function pad(n) {
      return (n < 10 ? '0' : '') + n;
    }
    return pad(h) + ':' + pad(m) + ':' + pad(s);
  }

  var badges = [];

  function injectBadges() {
    var links = document.querySelectorAll(BADGE_SELECTOR);
    links.forEach(function (link) {
      if (link.dataset.countdownInjected) return;
      link.dataset.countdownInjected = 'true';
      link.classList.add('has-countdown-badge');

      var badge = document.createElement('span');
      badge.className = 'last-minute-countdown';
      badge.setAttribute('aria-hidden', 'true');
      var titleGroup = link.querySelector('.sliderow__title-content') || link;
      titleGroup.appendChild(badge);
      badges.push(badge);
    });
  }

  function tick() {
    if (!badges.length) return;
    var end = ensureEndTime();
    var text = formatDuration(end - Date.now());
    badges.forEach(function (badge) {
      badge.textContent = text;
    });
  }

  function init() {
    ensureEndTime();
    injectBadges();
    tick();
    setInterval(function () {
      injectBadges();
      tick();
    }, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
